import React from "react";
import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { graphql, useLazyLoadQuery } from "react-relay";
import { TeamScheduleHistoryMasterList } from "./TeamScheduleHistoryMasterList";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RouteProp, CompositeNavigationProp } from "@react-navigation/native";
import { ParamList } from "./TeamScheduleHistoryStack";
import { TeamScheduleHistoryListScreenQuery } from "./__generated__/TeamScheduleHistoryListScreenQuery.graphql";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";

export function TeamScheduleHistoryListScreen(props: {
  navigation: CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"TeamScheduleHistory">,
    NativeStackNavigationProp<ParamList, "TeamScheduleHistoryScreen">
  >;
  route: RouteProp<ParamList, "TeamScheduleHistoryScreenList">;
}) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fk) => <TeamScheduleHistoryListScreenCmp {...props} fetchKey={fk} />}
    </LazyQueryNetworkBoundrary>
  );
}
function TeamScheduleHistoryListScreenCmp(props: {
  navigation: CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"TeamScheduleHistory">,
    NativeStackNavigationProp<ParamList, "TeamScheduleHistoryScreen">
  >;
  route: RouteProp<ParamList, "TeamScheduleHistoryScreenList">;
  fetchKey: string;
}) {
  const data = useLazyLoadQuery<TeamScheduleHistoryListScreenQuery>(
    graphql`
      query TeamScheduleHistoryListScreenQuery(
        $teamId: ID!
        $first: Int
        $after: String
        $freq: RoutineScheduleType!
      ) {
        store {
          team(id: $teamId) {
            id
            name
            ...TeamScheduleHistoryMasterList_team
          }
        }
      }
    `,
    {
      teamId: props.route.params.teamId,
      first: 20,
      freq: props.route.params.freq,
    },
    {
      fetchPolicy: "store-and-network",
    }
  );
  if (!data.store.team) {
    return null;
  }
  return (
    <TeamScheduleHistoryMasterList
      onSelect={(id) => {
        props.navigation.navigateDeprecated("TeamScheduleHistoryScreenDetail", {
          id,

          teamId: props.route.params.teamId,
        });
      }}
      currentId={null}
      team={data.store.team}
    />
  );
}
